import { CommonModule } from '@angular/common';
import {
    Component,
    computed,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    Signal,
    WritableSignal,
} from '@angular/core';
import {
    EventTraceNode,
    IqBuilderAuditToolsService,
} from '../../iq-builder-audit-tools.service';
import {
    EventsTraceDiagramComponent,
    EventTraceMap,
} from './events-trace-diagram.component';

@Component({
    selector: 'iq-builder-events-trace',
    standalone: true,
    imports: [CommonModule, EventsTraceDiagramComponent],
    templateUrl: './events-trace.component.html',
    styleUrl: './events-trace.component.scss',
})
export class EventsTraceComponent {
    traceId: InputSignal<string> = input<string>();
    private readonly _toolService: IqBuilderAuditToolsService = inject(
        IqBuilderAuditToolsService,
    );

    payload: WritableSignal<any> = signal(null);
    selectedName: WritableSignal<string> = signal('');

    constructor() {}

    traceMap: Signal<EventTraceMap> = computed(() => {
        const nodes: EventTraceNode[] = this._toolService.eventChain(
            this.traceId(),
        )();
        const links = nodes.map((node) => {
            return {
                targetEvent: this._toolService.renderedAction(node.id)(),
                sourceEvent: this._toolService.renderedAction(node.parentId)(),
                meta: node.meta,
            };
        });
        const uniqueIds = [
            ...new Set<string>(
                nodes.map((node) => [node.id, node.parentId]).flat(),
            ),
        ];
        const mappedNodes = uniqueIds.map((id) => {
            return {
                id: id,
                info: this._toolService.renderedAction(id)(),
            };
        });

        return {
            nodes: mappedNodes,
            links,
        };
    });

    selectEvent(evtId: string) {
        const selectedAction = this._toolService.renderedActions()?.[evtId];

        console.log('Selected Action:', selectedAction);

        this.payload.set(selectedAction.evt.payload);
        this.selectedName.set(selectedAction.evt.name);
    }
}
